module.exports = {"451421100":"新宁镇","451421101":"渠黎镇","451421102":"渠旧镇","451421103":"柳桥镇","451421104":"东门镇","451421105":"山圩镇","451421106":"中东镇","451421107":"东罗镇","451421201":"龙头乡","451421202":"岜盆乡","451421203":"昌平乡","451421400":"广西农垦国有山圩农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451421.json
// module id = 2001
// module chunks = 0